(() => {
  const bind = () => document.querySelectorAll('[data-bkb-sale]').forEach(root => {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';
    const end = Date.parse(root.dataset.end);
    if (!Number.isFinite(end)) return;
    let timer;
    const tick = () => {
      const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (!remaining && !window.Shopify?.designMode) {
        root.hidden = true;
        clearInterval(timer);
        return;
      }
      const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      root.querySelectorAll('[data-bkb-unit]').forEach((el, i) => { el.textContent = String(values[i]).padStart(2, '0'); });
    };
    timer = setInterval(tick, 1000);
    tick();
  });
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
